import React, { useEffect, useRef } from "react"

const TextArea = ({ text, setText, placeholder, trigger, title }) => {
  const textareaRef = useRef(null)
  const spanText = title || "Description / Instruction"
  const handleChange = (event) => {
    setText(event.target.value)
    adjustTextareaHeight()
  }

  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`
    }
  }

  useEffect(() => {
    adjustTextareaHeight()
  }, [trigger])

  return (
    <div className="flex flex-col">
      <span className="text-text-secondary ml-4 mb-2 text-md text-start max-w-max">
        {spanText}
      </span>
      <textarea
        ref={textareaRef}
        className="border border-divider rounded-lg p-2 resize-none focus:border-primary-main focus:outline-none overflow-hidden bg-paper text-text-primary"
        placeholder={placeholder}
        value={text}
        onChange={handleChange}
        style={{
          minHeight: '104px',
          transition: 'height 0.2s',
        }}
      />
    </div>
  )
}
export default TextArea